import { Grid } from "antd";
import { useMemo } from "react";

const { useBreakpoint } = Grid;
/**
 *
 * @return {object} { xs, sm, md, lg, xl, isDesktop }
 * @description isSmallScreen: is xs
 * @description isDesktop: is lg and xl
 */
export const useScreen = () => {
  const { xs, sm, md, lg, xl, xxl } = useBreakpoint();
  const isDesktop = useMemo(() => lg || xl, [lg, xl]);
  return { xs, sm, md, lg, xl, xxl, isDesktop };
};
